import Swal from 'sweetalert2';
import { Autocomplete } from '@mui/material';
import { Grid } from '@mui/material';
import { Modal } from '../../../components/BootstrapToMUI';
import React, { useEffect } from 'react';
import { Checkbox, Select, Divider } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { InputAdornment } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Controller, useForm } from 'react-hook-form';
import { TextField, Button, MenuItem, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import request from '../../../services/Request';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'left',
  },
  formControl: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    minWidth: 120,
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 1, 2),
  },
}));

export default function AddBundleToMachine(props) {
  const classes = useStyles();
  const {
    id,
    bundle,
    selectBundle,
    filterd,
    setSelectBundle,
    referTo,
    reflesh,
    setFiltered,
    setReflesh,
    ...rest
  } = props;

  const defaultValues = {
    selectBundle: [],
  };

  const { handleSubmit, control, watch, reset, setValue } = useForm({ defaultValues });

  useEffect(() => {
    if (props.show) {
      console.log('filterd', filterd);
      console.log('bundle', bundle);
      reset(defaultValues);
      let selectBundle = [];
      if (filterd.length > 0 && filterd[0].products_bundle.length > 0) {
        filterd?.[0]?.products_bundle.forEach((bd) => {
          const findindex = bundle.findIndex((e) => e._id === bd);
          if (findindex > -1) {
            selectBundle.push(bundle[findindex]);
          }
        });
        setValue('selectBundle', selectBundle);
      }
    }
  }, [props.show]);

  const onSubmit = async (formData) => {
    console.log('formData', formData);
    console.log('id', id);
    console.log('filterd', filterd);
    // props.setSelectBundle(formData.selectBundle);
    // props.setShow(false);

    let products_bundle = [];

    formData?.selectBundle?.forEach((prod) => {
      products_bundle.push(prod._id);
    });
    // console.log(prodsb);
    let lasturl = window.location.href.split('/').pop();
    const machineID = lasturl != 'all' ? lasturl : null;
    let finalMachine = machineID ? new Array(machineID) : filterd.map((e) => e._id);
    console.log('products_bundle', products_bundle);
    console.log('finalMachine', finalMachine);
    console.log('machineID', machineID);

    await request({
      method: 'post',
      url: `/machines/addBundleTomachine`,
      data: {
        machineID: finalMachine,
        products_bundle: products_bundle,
      },
    }).then((e) => {
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Bundle added successfully',
      }).then(() => {
        setReflesh(!reflesh);
        setFiltered((preMC) =>
          preMC.map((mc) => ({
            ...mc,
            products_bundle: formData?.selectBundle?.map((e) => e._id),
          }))
        );
        props.onHide();
      });
    });
  };

  const watchAllFields = watch();
  return (
    <Modal className="modal-w" {...rest} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Add Bundle To Machines</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <Grid item xs={12}>
            <Controller
              name="selectBundle"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  multiple
                  options={bundle}
                  value={watchAllFields.selectBundle}
                  disableCloseOnSelect
                  onChange={(event, value) => {
                    field.onChange(value);
                  }}
                  isOptionEqualToValue={(option, value) => option._id === value._id}
                  getOptionLabel={(option) => option.name.en}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option?.name?.en + `(` + option?.description?.en + `)`}
                    </li>
                  )}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Bundles" />
                  )}
                />
              )}
            />
          </Grid>
          <Button
            variant="contained"
            color="primary"
            type="submit"
            style={{
              width: '100%',
              marginTop: '20px',
            }}
          >
            Submit
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}
